"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLogger = void 0;
const console_logger_1 = require("./console-logger");
const helpers_1 = require("../../helpers");
class AppLogger {
    constructor() {
        this.$name = 'app-logger';
        this._loggers = [];
        this._debugEnabled = false;
    }
    debug(obj) {
        if (this._debugEnabled) {
            const updatedObj = Object.assign({ timestamp: Date.now() }, obj);
            for (const logger of this._loggers) {
                try {
                    logger.debug(updatedObj);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    }
    error(obj) {
        const updatedObj = Object.assign({ timestamp: Date.now() }, obj);
        for (const logger of this._loggers) {
            try {
                logger.error(updatedObj);
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    info(obj) {
        const updatedObj = Object.assign({ timestamp: Date.now() }, obj);
        for (const logger of this._loggers) {
            try {
                logger.info(updatedObj);
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    configure(config) {
        this._debugEnabled = config.debugEnabled;
    }
    static configure(config) {
        AppLogger.instance.configure(config);
    }
    static debug(obj) {
        AppLogger.instance.debug(obj);
    }
    static error(obj) {
        AppLogger.instance.error(obj);
    }
    static info(obj) {
        AppLogger.instance.info(obj);
    }
    static addConsole() {
        if (!helpers_1.ArrayHelper.any(AppLogger.instance._loggers, l => l instanceof console_logger_1.ConsoleLogger)) {
            AppLogger.instance._loggers.push(console_logger_1.ConsoleLogger.instance);
        }
    }
    static add(logger) {
        AppLogger.instance._loggers.push(logger);
    }
}
exports.AppLogger = AppLogger;
AppLogger.instance = new AppLogger();
//# sourceMappingURL=app-logger.js.map